
import Component from 'vue-class-component';
import Vue from 'vue';
import DefaultHeader from '@/components/layouts/DefaultHeader.vue';
import stores from '@/store/core/RootStore';

@Component({
  name: 'LayoutDefault',
  components: { DefaultHeader },
})
export default class LayoutAuth extends Vue {
  user = stores.user;

  async mounted() {
    await this.user.GETUSER();
  }
}
